var HelperUrl = {

    /**
     * @param string query
     * @returns {string}
     */
    decode: function(query) {
        var decodeRE = /\+/g;
        return decodeURIComponent(query.replace(decodeRE, " "));
    },

    /**
     * @param string query
     */
    parseUrlParams: function(query) {
        var params = {}, e;
        var re = /([^&=]+)=?([^&]*)/g;
        while (e = re.exec(query)) {
            var key = this.decode(e[1]), value = this.decode(e[2]);
            if (key.substring(key.length - 2) === '[]') {
                key = key.substring(0, key.length - 2);
                (params[key] || (params[key] = [])).push(value);
            }
            else params[key] = value;
        }
        return params;
    }
}

export default HelperUrl;
